<template>
  <div class="main payment" v-loading="isLoading">
    <div class="part1">
      <div>
        <div class="payment-title">{{ $t('prices-payment-title1') }}：</div>
        <el-input v-model="input" :placeholder="$t('prices-payment-title1')"></el-input>
      </div>
      <div class="payment-option">
        <div class="payment-title">{{ $t('prices-payment-title3') }}：</div>
        <el-select v-model="value" :placeholder="$t('prices-payment-title4')" @change="change">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="total-price">
        <span class="payment-title">{{ $t('prices-payment-title5') }}：</span>
        <span class="payment-title price">{{totalPrice}}</span>
      </div>
      <div>
        <span class="payment-title">{{ $t('prices-payment-title6') }}：</span>
        <el-radio v-model="radio" label="PayPal">PayPal</el-radio>
      </div>
      <div id="pay" @click="orderConfirm">{{ $t('prices-payment-title8') }}</div>
    </div>
    <div class="part2">
      <div>{{ $t('prices-payment-title9') }}：</div>
      <div class="agreement"><a target="_blank" href="/permission/#/agreement">{{ $t('prices-payment-title10') }}</a></div>
      <div class="policy"><a target="_blank" href="/permission/#/privacypolicy">{{ $t('prices-payment-title11') }}</a></div>
    </div>
  </div>
</template>

<script>
//  import bus from '../../assets/js/EventBus'
  import state from '../../assets/js/state'
  export default {
    name: 'Payment',
    data () {
      return {
        options: [],
        input: '',
        value: '',
        radio: 'PayPal',
        totalPrice: 0,
        paymentPlan: '',
        type: '',
        selectedProductId: '',
        isLoading: false,
        username: ''
      }
    },
    created () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.getProductList()
    },
    methods: {
      getProductList () {
        this.$axios.post('/proxy-api/client/pay/product/get-product-list', this.qs.stringify({
          platform: 1,
          language: window.navigator.userLanguage || window.navigator.language
        })).then(res => {
          if (res.data.status === '0') {
            let productList = res.data.payload.product_list
            if (!productList) return false
            this.options = productList.map((item, index) => {
              return {
                value: index,
                label: item['product_name'] + ' / ' + '$' + item['now_price'],
                proId: item['id']
              }
            })
            this.value = res.data.payload.focus
            this.checkPrice()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
              duration: 2000
            })
            return false
          }
        }).catch(err => {
          this.$message.error(this.$t('prices-payment-title12'))
          console.log(err)
        })
      },
      checkPrice () {
        this.totalPrice = this.options[this.value].label.substr(this.options[this.value].label.indexOf('/') + 2)
        this.paymentPlan = this.options[this.value].label.substr(0, this.options[this.value].label.indexOf('/') - 1)
        this.selectedProductId = this.options[this.value]['proId']
      },
      createOrder () {
        this.isLoading = false
        this.$axios.post('/proxy-api/client/pay/orders/create-orders', this.qs.stringify({
          account: this.input,
          type: this.type,
          product_id: this.selectedProductId,
          pay_method: 0// 0 paypal
        })).then(res => {
          if (res.data.status === '0') {
            state.saveData({
              orderId: res.data.payload['order_id'],
              account: this.input,
              paymentPlan: this.options[this.value].label,
              username: this.username
            })
            this.$router.push('/Prices/Confirm')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
              duration: 2000
            })
            return false
          }
        }).catch(err => {
          this.$message.error(this.$t('prices-payment-title12'))
          console.log(err)
        })
      },
      orderConfirm () {
        if (this.input.trim() === '') {
          this.$message({
            message: this.$t('prices-payment-title13'),
            type: 'warning',
            duration: 2000
          })
          return false
        }
        this.isLoading = true
        let emailReg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/
        let phoneReg = /^([\d]{5,20})$/
        if (emailReg.test(this.input)) {
          this.type = 1
        } else if (phoneReg.test(this.input)) {
          this.type = 2
        } else {
          this.type = 3
        }
//        let params = {
//          totalPrice: this.totalPrice,
//          paymentPlan: this.paymentPlan,
//          paymentWay: this.radio,
//          account: this.input,
//          comeFromPaymentPage: true
//        }
        this.$axios.post('/proxy-api/client/pay/product/get-buyer-info', this.qs.stringify({
          account: this.input,
          type: this.type
        })).then(res => {
          if (res.data.status === '0') {
            this.username = res.data.payload.username
            this.createOrder()
          } else {
            this.isLoading = false
            this.$message({
              message: res.data.msg,
              type: 'warning',
              duration: 2000
            })
            return false
          }
        }).catch(err => {
          this.isLoading = false
          this.$message.error(this.$t('prices-payment-title12'))
          console.log(err)
        })
//        setTimeout(() => {
//          bus.$emit('passParams', params)
//        }, 500)
//        this.$router.push('/Prices/Confirm')
      },
      change (val) {
        this.checkPrice()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .payment {
    /*padding: 1rem 3rem;*/
    width: 5rem;
    margin: 1.33rem auto 1.1rem !important;
    @media screen and (max-width: 760px){
      width: 3rem;
      margin: 1rem auto .54rem !important;
    }
    .payment-title {
      font-size: 0.2rem;
      color: #323232;
      margin-bottom: .1rem;
    }
    .el-input, .el-select {
      width: 3rem !important;
    }
    .part1 {
      > div {
        margin-top: .25rem;
      }
      .total-price {
        .price {
          color: #00a7ff;
        }
      }
    }
    .part2 {
      margin-top: .95rem;
      font-size: .2rem;
      @media screen and (max-width: 760px){
        margin-top: .3rem;
      }
      a {
        color: #5CA4EC;
        text-decoration: none;
      }
      .agreement {
        margin-top: .3rem;
      }
      .policy {
        margin-top: .2rem;
      }
    }
    #pay {
      width: 2rem;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.2rem;
      background: #5CA4EC;
      border-radius: 3px;
      font-weight: 400;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// Payment.vue?15a4186c